export default __webpack_public_path__ + "static/media/cases1.14ddf408.jpg";